import { render, staticRenderFns } from "./LessonNavigation.vue?vue&type=template&id=ba828986"
import script from "./LessonNavigation.vue?vue&type=script&lang=js"
export * from "./LessonNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports